/* 
    拖拽区域布局组件
    created by: liyaoh 2019-04-30
*/
import React, { Component } from 'react';

class DragArea extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    
    //渲染children
    renderChildren = () => {
        const { children, onDragItemClick } = this.props;
        return React.Children.map(children, (child) => {
            //将父组件事件绑定到子组件上
            return React.cloneElement(child, {
                onDragItemClick: onDragItemClick && onDragItemClick.bind(this, child.props)
            });
        });
    }

    render() {
        const { headerTitle, renderHeader } = this.props;
        return (
            <div className="side-panel">
                <div className="panel-header">
                {
                    renderHeader ? renderHeader : 
                    <span className="title">{headerTitle}</span>
                }
                </div>
                <div className="panel-content clearfix">
                    {this.renderChildren()}
                </div>
            </div>
        )
    }
}

export default DragArea;